import { Company } from '@shared/models';

export interface CompaniesResponse {
  status: boolean;
  message: Company[];
}
